import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useTranslations from '@/i18n/useTranslations';
import QueuedArticlesPopup from "@/pages/profile/board/components/QueuedArticlesPopup";
import QueuedPostsPopup from "@/pages/profile/post/components/QueuedPostsPopup";
import GenericPopup from "@/shared-components/popups/components/GenericPopup";
import Text from "@/shared-components/text/components/Text";

import "../../drafts/components/styles/PopUpCreateOptions.css";

const PopUpCreateOptionsForBoard = ({
  open,
  close,
  openDraftPopup,
  queuedPosts = [],
  queuedArticles = [],
  allowPosts = true,
  allowArticles = true,
}) => {
  const navigate = useNavigate();
  const t = useTranslations('common.profile.popups.create_options_board');
  const [queueType, setQueueType] = useState(null);

  const queuedPostsCount = queuedPosts.length;
  const queuedArticlesCount = queuedArticles.length;
  const hasQueuedPosts = queuedPostsCount > 0;
  const hasQueuedArticles = queuedArticlesCount > 0;
  const isPostsQueueOpen = queueType === 'posts';
  const isArticlesQueueOpen = queueType === 'articles';

  useEffect(() => {
    if (!queueType) return;
    if (queueType === 'posts' && !hasQueuedPosts) {
      setQueueType(null);
    }
    if (queueType === 'articles' && !hasQueuedArticles) {
      setQueueType(null);
    }
  }, [queueType, hasQueuedPosts, hasQueuedArticles]);

  return (
    <>
      <GenericPopup
        open={open}
        className="remove-scrollbar"
        backgroundClassName="pop-up-artwork-create__backdrop"
      >
        <div
          className="pop-up-artwork-create"
          onClick={(e) => {
            e.stopPropagation();
            close();
          }}
        >
          <div className="pop-up-artwork-create-container">
            {/* New Post Option */}
            {allowPosts && (
              <button
                type="button"
                className="pop-up-artwork-create-options"
                onClick={() => navigate("/profile/add-post")}
              >
                <Text>{t('options.post')}</Text>
              </button>
            )}

            {/* New Article Option */}
            {allowArticles && (
              <button
                type="button"
                className="pop-up-artwork-create-options"
                onClick={() => navigate("/profile/add-article")}
              >
                <Text>{t('options.article')}</Text>
              </button>
            )}

            {/* Open Drafts Option */}
            {(allowPosts || allowArticles) && (
              <button
                type="button"
                className="pop-up-artwork-create-options"
                onClick={() => {
                  close();
                  openDraftPopup(true);
                }}
              >
                <Text>{t('options.open_drafts')}</Text>
              </button>
            )}

            {/* Queued Posts Option */}
            {allowPosts && hasQueuedPosts && (
              <button
                type="button"
                className="pop-up-artwork-create-options"
                onClick={(event) => {
                  event.stopPropagation();
                  setQueueType('posts');
                  close();
                }}
              >
                <Text>{t('options.queued_posts', { count: queuedPostsCount })}</Text>
              </button>
            )}

            {/* Queued Articles Option */}
            {allowArticles && hasQueuedArticles && (
              <button
                type="button"
                className="pop-up-artwork-create-options"
                onClick={(event) => {
                  event.stopPropagation();
                  setQueueType('articles');
                  close();
                }}
              >
                <Text>{t('options.queued_articles', { count: queuedArticlesCount })}</Text>
              </button>
            )}
          </div>
        </div>
      </GenericPopup>

      {allowArticles && (
        <QueuedArticlesPopup
          open={isArticlesQueueOpen}
          onClose={() => setQueueType(null)}
          articles={queuedArticles}
        />
      )}

      <QueuedPostsPopup
        open={isPostsQueueOpen}
        onClose={() => setQueueType(null)}
        posts={queuedPosts}
      />
    </>
  );
};

export default PopUpCreateOptionsForBoard;
